import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupDisbandContentProps {
  message: Msg;
}

export const MsgGroupDisbandContent = memo(function MsgGroupDisbandContent({
  message,
}: MsgGroupDisbandContentProps) {
  const { t } = useTranslation();
  const { user_name, user_id } = message.payload;

  return (
    <>
      <MsgUserText userName={user_name} userId={user_id} />
      <Text as="span" color="fg.muted" px="1">
        {t('chat.groupMessageDisbandText')}
      </Text>
    </>
  );
});
